import { Component, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

import { CharacterService, MediaService } from '../../../_services/index';

@Component({
    selector: 'ngx-block-edit-modal',
    templateUrl: 'block-edit-modal.component.html',
    styleUrls: ['block-edit-modal.component.scss'],
    standalone: false
})
export class BlockEditModalComponent {

  originalModel;

  _model;
  @Input() set model(model){
    this._model = {...model};
    this.originalModel = model;
  };

  @Input() gameId;
  @Input() templateId;
  @Input() languages = [];
  @Input() defaultLang;
  @Input() editMode = false;
  @Input() htmlMode = true;

  characters;

  editor: any;

  constructor(protected ref: NbDialogRef<BlockEditModalComponent>,
    private characterService: CharacterService,
    private mediaService: MediaService) {
      
    
  }

  ngOnInit(): void {
    //this.initEditor();
    let charPath = `games/${this.gameId}/characters`;
    if(!this.gameId){
      charPath = `game_templates/${this.templateId}/characters`;
    }
    this.characterService.listCharacters(charPath)
    .subscribe(characters => {
      if(characters){
        this.characters = characters.sort((x, y) => x.orderNum - y.orderNum);
      }
    });
  }

  cancel() {
    this.ref.close();
  }

  save() {
    /*if(this.isStructuredBlock){
      this.editor
      .save()
      .then((outputData) => {
        console.log('Article data: ', JSON.stringify(outputData));
      })
      .catch((error) => {
        console.log('Saving failed: ', error);
      });
    }*/
    //this.originalModel = this._model;
    Object.assign(this.originalModel, this._model);
    this.ref.close(this.originalModel);
  }
}
